import React, { useState, useEffect, useContext } from "react"
import Slider from '@mui/material/Slider'
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faLockOpen } from '@fortawesome/free-solid-svg-icons'
// import { faLock } from '@fortawesome/free-solid-svg-icons'
import axios from "axios"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  // Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import ProfileListComponent from "./ProfileListComponent"
import {ProfileContext, CompareContext} from "../App"
import '../App.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  // Tooltip,
  Legend,
);


function HomeComponent() {

    const profileContext = useContext(ProfileContext)
    const compareContext = useContext(CompareContext)
    // items at their indicies 
    //  profileContext = [
    //     0 => profileName,
    //     1 => flowRate,
    //     2 => hv,
    //     3 => lv,
    //     4 => dutyCycle,
    //     5 => frequency
    // ]

    const handleSave = async (event) => {
        event.preventDefault()
        if (profileContext[0] === "") {
            window.alert("Profile name must be provided.")
            return " "
        }
        if (profileContext.includes(0)) {
            window.alert("Profile values must be between 1 and 10.")
            return " "
        }
        // This is REGEX, it allows us to test for only numbers and letters in the profile name
        if (/^[A-Za-z0-9]*$/.test(profileContext[0])) {
            const newProfile = {
                "profileName": profileContext[0],
                "flowRate": profileContext[1],
                "hv": profileContext[2],
                "lv": profileContext[3],
                "dutyCycle": profileContext[4],
                "frequency": profileContext[5]           
            }
            const token = localStorage.getItem("token")
            const payload = {"profile": newProfile, "user": localStorage.getItem("username")}
            const response = await axios.post("http://18.234.199.102:5000/profiles/create", payload, {headers:{
                'Access-Control-Allow-Origin' : '*',
                "Authorization": `Bearer ${token}`
            }})
            if (response.data === "You already have a profile with this name. Please change name and try again") {
                window.alert("You already have a profile with this name. Please change name and try again")
            } else {
                window.alert(response.data)
                window.location.reload()               
            }
        } else {
            window.alert("Profile name can only contain letters and numbers.")
            return " "
        }
    }

    const [tabIndex, setTabIndex] = useState(0)
    const [compareIndex, setCompareIndex] = useState(0)
    const [profileName, setProfileName] = useState(profileContext[0])
    const [flowRate, setFlowRate] = useState(profileContext[1])
    const [hv, setHv] = useState(profileContext[2])
    const [lv, setLv] = useState(profileContext[3])
    const [dutyCycle, setDutyCycle] = useState(profileContext[4])
    const [frequency, setFrequency] = useState(profileContext[5])
    const [profileId, setProfileId] = useState("")

    const [compareProfileName, setCompareProfileName] = useState(compareContext[0])
    const [compareFlowRate, setCompareFlowRate] = useState(compareContext[1])
    const [compareHv, setCompareHv] = useState(compareContext[2])
    const [compareLv, setCompareLv] = useState(compareContext[3])
    const [compareDutyCycle, setCompareDutyCycle] = useState(compareContext[4])
    const [compareFrequency, setCompareFrequency] = useState(compareContext[5])

    const [twoProfilesToCompare, setTwoProfilesToCompare] = useState([])
    const [singleProfileView, setSingleProfileView] = useState(false)
    const [singleProfile, setSingleProfile] = useState("")

    const [dataArray, setDataArray] = useState([])
    const [compareDataArray, setCompareDataArray] = useState([])
    const [energyDataArray, setEnergyDataArray] = useState([])
    const [compareEnergyDataArray, setCompareEnergyDataArray] = useState([])
    const [labels, setLabels] = useState([])
    const [compareLabels, setCompareLabels] = useState([])
    const [compare, setCompare] = useState(false)

    // const [flowRateLock, setFlowRateLock] = useState(false)
    // const [hvLock, setHvLock] = useState(false)
    // const [lvLock, setLvLock] = useState(false)
    // const [dutyCycleLock, setDutyCycleLock] = useState(false)
    // const [frequencyLock, setFrequencyLock] = useState(false)

    const flowRateDef = "The flow rate at which an individual sample travels through the flow chamber"
    const hvDef = "The highest voltage the sample is electrified with"
    const lvDef = "The lowest voltage the sample is electrified with"
    const dutyCycleDef = "The amount of time the highest electrified signal is sent to a sample"
    const frequencyDef = "The amount of time a sample receives a charge from the electrode"

    const handleTabChange = (event, newTabIndex) => {
      setSingleProfileView(false)
      setTabIndex(newTabIndex)
    }

    const handleCompareChange = (event, newCompareIndex) => {
      setCompareIndex(newCompareIndex)
    }

    const handleProfileName = (event) => {
        setProfileName(event.target.value)
        profileContext[0] = event.target.value
    }

    const handleFlowRate = (event) => {
        setFlowRate(event.target.value)
        profileContext[1] = event.target.value
    }

    const handleHv = (event) => {
        setHv(event.target.value)
        profileContext[2] = event.target.value
    }

    const handleLv = (event) => {
        setLv(event.target.value)
        profileContext[3] = event.target.value
    }

    const handleDutyCycle = (event) => {
        setDutyCycle(event.target.value)
        profileContext[4] = event.target.value
    }

    const handleFrequency = (event) => {
        setFrequency(event.target.value)
        profileContext[5] = event.target.value
    }

    // COMMENTING THESE HELPER FUNCTIONS OUT UNTIL WE CHOOSE TO USE THE LOCK/UNLOCK FUNCTIONALITY IN THE FUTURE
    // IF WE CHOOSE TO USE THEM AGAIN, MAKE SURE TO UNCOMMENT THE CODE IN THE EACH SLIDER, INCLUDING THE SLIDER COMPONENT WITH THE DISABLED PARAM

    // const handleFlowLock = (event) => {
    //     setFlowRateLock(!flowRateLock)
    // }

    // const handleHvLock = (event) => {
    //     setHvLock(!hvLock)
    // }

    // const handleLvLock = (event) => {
    //     setLvLock(!lvLock)
    // }

    // const handleDutyCycleLock = (event) => {
    //     setDutyCycleLock(!dutyCycleLock)
    // }

    // const handleFrequencyLock = (event) => {
    //     setFrequencyLock(!frequencyLock)
    // }

    const handleTwoProfilesToCompare = (profile) => {
      // This function allows us to set the state variable of the profile we wish to compare.

      // Edge case to handle when a user selects to compare while in single profile view mode
      setSingleProfile("")
      setSingleProfileView(false)

      // If there is less than one profile selected, set the state variable to contain
      // the selected profile
      if (twoProfilesToCompare.length === 0) {
            setTwoProfilesToCompare([profile[1]])

            mainContextSetter(profileContext, profile, false)

            return
      }
      if (twoProfilesToCompare.length == 1 && twoProfilesToCompare.includes(profile[1])) {
          setTwoProfilesToCompare([])
          contextReseter(profileContext)

          setFlowRate(1)
          setHv(1)
          setLv(1)
          setDutyCycle(1)
          setFrequency(1)

          return

      }
      if (twoProfilesToCompare.length == 1) {
        // If there is only one profile, add the second profile to the state variable
        setTwoProfilesToCompare([twoProfilesToCompare[0], profile[1]])

        compareContext[0] = profile[1]
        setCompareProfileName(profile[1])

        compareContext[1] = profile[2]
        setCompareFlowRate(profile[2])

        compareContext[2] = profile[3]
        setCompareHv(profile[3])

        compareContext[3] = profile[4]
        setCompareLv(profile[4])

        compareContext[4] = profile[5]
        setCompareDutyCycle(profile[5])

        compareContext[5] = profile[6]
        setCompareFrequency(profile[6])

        return
      }
      if (twoProfilesToCompare.length > 1 && twoProfilesToCompare.includes(profile[1])) {
      // if we have two profiles and one of them is clicked on...
        let firstProfile = twoProfilesToCompare[0]
        let secondProfile = twoProfilesToCompare[1]

        // if it is the first profile, create a var to hold compare values,
        // reset compare context, and apply these old compare values to
        // the profileContext, also remove profile from twoProfilesToCompare state var
        if (profile[1] === firstProfile) {

          let newContext = [
              compareContext[0],
              compareContext[1],
              compareContext[2],
              compareContext[3],
              compareContext[4],
              compareContext[5],
            ]
          mainContextSetter(profileContext, newContext, true)

          contextReseter(compareContext)

          setCompareProfileName("")
          setCompareFlowRate(1)
          setCompareHv(1)
          setCompareLv(1)
          setCompareDutyCycle(1)
          setCompareFrequency(1)

          setTwoProfilesToCompare([secondProfile])
          return
        }
        // if it is the second profile, rest the compare context and remove profile
        // from the twoProfilesToCompare state var
        if (profile[1] === secondProfile) {

          contextReseter(compareContext)

          setCompareProfileName("")
          setCompareFlowRate(1)
          setCompareHv(1)
          setCompareLv(1)
          setCompareDutyCycle(1)
          setCompareFrequency(1)

          setTwoProfilesToCompare([firstProfile])
          return
        }
      }  
    }


    const handleResetValues = () => {

        setFlowRate(1)
        profileContext[1] = 1

        setHv(1)
        profileContext[2] = 1

        setLv(1)
        profileContext[3] = 1

        setDutyCycle(1)
        profileContext[4] = 1

        setFrequency(1)
        profileContext[5] = 1

    }

    const contextReseter = (context) => {
      context[0] = ""
      context[1] = 1
      context[2] = 1
      context[3] = 1
      context[4] = 1
      context[5] = 1
    }

    const mainContextSetter = (context, profile, fromContext = false) => {
      // In this function, we have to account for context values being added from either
      // a given profile, or the compareContext since those array objects have different indices
      if (fromContext === false) {

        context[0] = profile[1] 

        context[1] = profile[2]
        setFlowRate(profile[2])
  
        context[2] = profile[3]
        setHv(profile[3])
  
        context[3] = profile[4]
        setLv(profile[4])
  
        context[4] = profile[5]
        setDutyCycle(profile[5])
  
        context[5] = profile[6]
        setFrequency(profile[6])

      } else {

        context[0] = profile[0] 
  
        context[1] = profile[1]
        setFlowRate(profile[1])
  
        context[2] = profile[2]
        setHv(profile[2])
  
        context[3] = profile[3]
        setLv(profile[3])
  
        context[4] = profile[4]
        setDutyCycle(profile[4])
  
        context[5] = profile[5]
        setFrequency(profile[5])
      }
    }

    const graphBuilderHelper = (labels, dataArray, fakeDC, fakeHV, fakeLV, size, context) => {
      let j = 0
      for (let i = 0; i < size; i++) {
        labels.push(i)
        if (j < fakeDC / context[5]) {
          dataArray.push(fakeHV)
        } else {
          dataArray.push(fakeLV)
        }
        j++
        if (j > 500 / context[5]) {
          j = 0
        }
      }

      while (labels.length < 1000) {
        labels.push(labels.length)
      }

      setDataArray(dataArray)
      setLabels(labels)

    }

    const barBuilderHelper = (labels, dataArray, fakeDC, fakeHV, fakeLV, size, context) => {
      let j = 0

      for (let i = 0; i < size; i++) {
        labels.push(i)
        if (j < fakeDC / context[5]) {
          dataArray.push(fakeHV * fakeHV)
        } else {
          dataArray.push(fakeLV * fakeLV)
        }
        j++
        if (j > 500 / context[5]) {
          j = 0
        }
      }

      let sum = 0
      
      for (let i = 0; i < dataArray.length; i++) {
          let currentNum = dataArray[i]
          sum += currentNum
      }

      let energyData = Math.sqrt(sum)
      setEnergyDataArray(energyData)
    }

    useEffect(() => {
      // This useEffect is solely for the line graph for a single wave
      // It takes into account the context for profileContext(current profile in creation) and
      // the context for singleProfileContext(the profile a user wants to view on the right hand side of the page)
      let size = (1000 * 6) / (6 + profileContext[1] - 1)

      let fakeDC = (profileContext[4] / 11) * 500

      let fakeHV = (profileContext[2] * 5) + 50

      let fakeLV = profileContext[3] * 4

      let newArray = []
      let newLabels = []

      graphBuilderHelper(newLabels, newArray, fakeDC, fakeHV, fakeLV, size, profileContext)
    
    }, [profileContext[1], profileContext[2], profileContext[3], profileContext[4], profileContext[5], singleProfileView, singleProfile])


    useEffect(() => {
      // This useEffect is for the compared line graph
      let size = (1000 * 6) / (6 + compareContext[1] - 1)

      let compareDC = (compareContext[4] / 11) * 500

      let compareHV = (compareContext[2] * 5) + 50

      let compareLV = compareContext[3] * 4

      let compareDataArray = []
      let newCompareLabels = []

      let j = 0

      for (let i = 0; i < size; i++) {
        newCompareLabels.push(i)
        if (j < compareDC / compareContext[5]) {
          compareDataArray.push(compareHV)
        } else {
          compareDataArray.push(compareLV)
        }
        j++
        if (j > 500 / compareContext[5]) {
          j = 0
        }
      }

      while (newCompareLabels.length < 1000) {
        newCompareLabels.push(newCompareLabels.length)
      }
      setCompareDataArray(compareDataArray)
      setCompareLabels(newCompareLabels)
      setCompareProfileName(compareContext[0])
      setCompareFlowRate(compareContext[1])
      setCompareHv(compareContext[2])
      setCompareLv(compareContext[3])
      setCompareDutyCycle(compareContext[4])
      setCompareFrequency([5])
    
    }, [compareContext[1], compareContext[2], compareContext[3], compareContext[4], compareContext[5]])

    const options = {
      animation: {
        duration: 0
      },
      scales: {
        y : {
          max: 100,
          min: 0,
          ticks: {
            display: false
          },
          title: {
            display: true,
            text: "Voltage"
          },
        },
        x : {
          max: 10000,
          min: 0,
          ticks: {
            display: false
          },
          title: {
            display: true,
            text: "Cell Residence Time"
          },
        }
      },
      responsive: true,
      interaction:{
        intersect: false,
        axis: "x"
      },
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: true,
          text: 'Waveform Profile Chart',
        },
      },
    };

    const compareOptions = {
      animation: {
        duration: 0
      },
      scales: {
        y : {
          max: 100,
          min: 0,
          ticks: {
            display: false
          },
          title: {
            display: true,
            text: "Voltage"
          },
        },
        x : {
          max: 10000,
          min: 0,
          ticks: {
            display: false
          },
          title: {
            display: true,
            text: "Cell Residence Time"
          },
        }
      },
      responsive: true,
      interaction:{
        intersect: false,
        axis: "x"
      },
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
        title: {
          display: true,
          text: 'Waveform Profile Chart',
        },
      },
    };

    const data = {
      labels: labels,
      datasets: [
        {
          label: profileContext[0],
          data: dataArray,
          borderColor: '#739eff',
          backgroundColor: '#739eff',
          stepped: true,
          // fill: true,
        },
        
      ],
    };

  const compareData = {
      labels: labels,
      datasets: [
        {
          label: profileContext[0],
          data: dataArray,
          borderColor: '#739eff',
          backgroundColor: '#739eff',
          stepped: true,
          // fill: true,
        },
        {
          label: compareContext[0],
          data: compareDataArray,
          borderColor: '#FF9900',
          backgroundColor: '#FF9900',
          stepped: true,
        }
      ],
    };

    useEffect(() => {
      // This useEffect is solely for the solo energy bar
      // It takes into account the context for profileContext(current profile in creation)
      let size = (1000 * 6) / (6 + profileContext[1] - 1)

      let fakeDC = (profileContext[4] / 11) * 500

      let fakeHV = (profileContext[2] * 5) + 50

      let fakeLV = profileContext[3] * 4
      
      let newArray = []
      let newLabels = []

      barBuilderHelper(newLabels, newArray, fakeDC, fakeHV, fakeLV, size, profileContext)

    
    }, [profileContext[1], profileContext[2], profileContext[3], profileContext[4]])


    useEffect(() => {
      // This useEffect is compared energy bar
      let size = (1000 * 6) / (6 + compareContext[1] - 1)
      let fakeDC = (compareContext[4] / 11) * 500
      let fakeHV = (compareContext[2] * 5) + 50
      let fakeLV = compareContext[3] * 4
      let newArray = []
      let newLabels = []
      let j = 0

      for (let i = 0; i < size; i++) {
        newLabels.push(i)
        if (j < fakeDC / compareContext[5]) {
          newArray.push(fakeHV * fakeHV)
        } else {
          newArray.push(fakeLV * fakeLV)
        }
        j++
        if (j > 500 / compareContext[5]) {
          j = 0
        }
      }

      let sum = 0
      
      for (let i = 0; i < newArray.length; i++) {
          let currentNum = newArray[i]
          sum += currentNum
      }

      let energyData = Math.sqrt(sum)
      setCompareEnergyDataArray(energyData)

    
    }, [compareContext[1], compareContext[2], compareContext[3], compareContext[4]])

    const energyOptions = {
      scales: {
          x : {
              max: 3050,
              min: 0,
              ticks: {
                display: false
              }
          }
      },
      indexAxis: 'y',
      elements: {
        bar: {
          // borderWidth: 2,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Wave Energy',
        },
      },
    };

  const energyLabels = ["Energy"];

  const energyData = {
  labels: energyLabels,
  datasets: [
      {
      label: profileContext[0],
      data: [energyDataArray],
      borderColor: '#739eff',
      backgroundColor: '#739eff',
      },
  ],
  };

  const compareEnergyData = {
  labels: energyLabels,
  datasets: [
      {
      label: profileContext[0],
      data: [energyDataArray],
      borderColor: '#739eff',
      backgroundColor: '#739eff',
      },
      {
        label: compareContext[0],
        data: [compareEnergyDataArray],
        borderColor: '#FF9900',
        backgroundColor: '#FF9900',
      },
  ],
  };


    return(
    <div>
        <div className="box__container">
            <div className="box">
            {/* <Tabs value={compareIndex} onChange={handleCompareChange}>
              <Tab label="Solo Profile" value={0}></Tab>
              <Tab label="Compare 2 Profiles" value={1}></Tab>
            </Tabs> */}
            {/* <Box> */}
              {twoProfilesToCompare.length < 2 && (
                <>
                  <Line options={options} data={data} />
                  {singleProfileView === true && (
                    <div className="profile__values">
                      <div className="compare__context__values">{profileContext[0]} | Flowrate: {profileContext[1]} | High Voltage: {profileContext[2]} | Low Voltage: {profileContext[3]} | Duty Cycle: {profileContext[4]} | Frequency: {profileContext[5]}</div>
                    </div>
                  )}
                  <div className="energy__bar__container">
                    <Bar options={energyOptions} data={energyData}/>
                  </div>
                </>
              )}
            {/* </Box> */}
            {/* <Box> */}
              {twoProfilesToCompare.length == 2 && (
                <>
                  <Line options={compareOptions} data={compareData} />
                  {compareContext[0].length > 0 && (
                    <div className="profile__values">
                      <div className="compare__context__values">{profileContext[0]} | Flowrate: {profileContext[1]} | High Voltage: {profileContext[2]} | Low Voltage: {profileContext[3]} | Duty Cycle: {profileContext[4]} | Frequency: {profileContext[5]}</div>
                      <div className="compare__context__values">{compareContext[0]} | Flowrate: {compareContext[1]} | High Voltage: {compareContext[2]} | Low Voltage: {compareContext[3]} | Duty Cycle: {compareContext[4]} | Frequency: {compareContext[5]}</div>
                    </div>
                  )}
                  <div className="energy__bar__container">
                    <Bar options={energyOptions} data={compareEnergyData}/>
                  </div>
                </>
              )}
            {/* </Box> */}
            </div>
            <div className="box">
           
                <Tabs value={tabIndex} onChange={handleTabChange}>
                    <Tab label="Show Profiles" value={0}></Tab>
                    <Tab label="Create Profile" value={1}></Tab>
                    {/* <Tab label="Compare 2 Profiles" value={2}></Tab> */}
                </Tabs>
                <Box>
                {tabIndex === 0 && (
                    <ProfileListComponent stateFunctions={[setTabIndex, setCompareProfileName, setCompareFlowRate, setCompareHv, setCompareLv, setCompareDutyCycle, setCompareFrequency, handleTwoProfilesToCompare, twoProfilesToCompare, setTwoProfilesToCompare, singleProfileView, setSingleProfileView, setSingleProfile]}/>
                )}
                </Box>
                <Box>
                {tabIndex === 1 && (
                    <div className="profile__create__header">
                        <div>
                            <input className={profileName.length ? "profile__name__input" : "profile__name__input__red"} placeholder="(Enter Profile Name)" maxLength="15" onChange={handleProfileName}></input>
                        </div>
                        <div className="profile__create__box">
                        <div>

                <div className="slider__box">
                    <label className="slider__label">
                        Flow Rate: {profileContext[1]}
                    <Tooltip title={flowRateDef}>
                      <InfoIcon className="tooltip__icon" fontSize="small" />
                    </Tooltip>
                    </label>
                    <div className="slider">                   
                        <Slider defaultValue={1} step={.1} marks min={1} max={10} value={profileContext[1]} onChange={handleFlowRate} valueLabelDisplay="off"></Slider>
                        {/* <Slider disabled={flowRateLock} defaultValue={1} step={1} marks min={1} max={10} value={profileContext[1]} onChange={handleFlowRate} valueLabelDisplay="off"></Slider> */}
                        {/* {flowRateLock === false ?
                        <FontAwesomeIcon icon={faLockOpen} size="lg" className="lockIcon" onClick={handleFlowLock}/>
                    : (
                        <FontAwesomeIcon icon={faLock} size="lg" className="lockIcon" onClick={handleFlowLock}/>
                    )} */}
                        
                    </div>
                </div>

                <div className="slider__box">
                    <label className="slider__label">
                        High Voltage: {profileContext[2]}
                    <Tooltip title={hvDef}>
                      <InfoIcon className="tooltip__icon" fontSize="small" />
                    </Tooltip>
                    </label>
                    <div className="slider">
                        <Slider defaultValue={1} step={.1} marks min={1} max={10} value={profileContext[2]} onChange={handleHv} valueLabelDisplay="off"></Slider>
                        {/* <Slider disabled={hvLock} defaultValue={1} step={1} marks min={1} max={10} value={profileContext[2]} onChange={handleHv} valueLabelDisplay="off"></Slider> */}
                        {/* {hvLock === false ?
                        <FontAwesomeIcon icon={faLockOpen} size="lg" className="lockIcon" onClick={handleHvLock}/>
                    : (
                        <FontAwesomeIcon icon={faLock} size="lg" className="lockIcon" onClick={handleHvLock}/>
                    )} */}
                    </div>
                </div>
                <div className="slider__box">
                    <label className="slider__label">
                        Low Voltage: {profileContext[3]}
                    <Tooltip title={lvDef}>
                      <InfoIcon className="tooltip__icon" fontSize="small" />
                    </Tooltip>
                    </label>
                    <div className="slider">
                        <Slider defaultValue={1} step={.1} marks min={1} max={10} value={profileContext[3]} onChange={handleLv} valueLabelDisplay="off"></Slider>
                        {/* <Slider disabled={lvLock} defaultValue={1} step={1} marks min={1} max={10} value={profileContext[3]} onChange={handleLv} valueLabelDisplay="off"></Slider> */}
                        {/* {lvLock === false ?
                        <FontAwesomeIcon icon={faLockOpen} size="lg" className="lockIcon" onClick={handleLvLock}/>
                    : (
                        <FontAwesomeIcon icon={faLock} size="lg" className="lockIcon" onClick={handleLvLock}/>
                    )} */}
                    </div>
                </div>
                <div className="slider__box">
                    <label className="slider__label">
                        Duty Cycle: {profileContext[4]}
                    <Tooltip title={dutyCycleDef}>
                      <InfoIcon className="tooltip__icon" fontSize="small" />
                    </Tooltip>
                    </label>
                    <div className="slider">
                        <Slider defaultValue={1} step={.1} marks min={1} max={10} value={profileContext[4]} onChange={handleDutyCycle} valueLabelDisplay="off"></Slider>
                        {/* <Slider disabled={dutyCycleLock} defaultValue={1} step={1} marks min={1} max={10} value={profileContext[4]} onChange={handleDutyCycle} valueLabelDisplay="off"></Slider> */}
                        {/* {dutyCycleLock === false ?
                        <FontAwesomeIcon icon={faLockOpen} size="lg" className="lockIcon" onClick={handleDutyCycleLock}/>
                    :(
                        <FontAwesomeIcon icon={faLock} size="lg" className="lockIcon" onClick={handleDutyCycleLock}/>
                    )} */}
                    </div>
                </div>

                <div className="slider__box">
                    <label className="slider__label">
                        Frequency: {profileContext[5]}
                    <Tooltip title={frequencyDef}>
                      <InfoIcon className="tooltip__icon" fontSize="small" />
                    </Tooltip>
                    </label>
                    <div className="slider">
                        <Slider defaultValue={1} step={.1} marks min={1} max={10} valueLabelDisplay="auto" value={profileContext[5]} onChange={handleFrequency}></Slider>
                        {/* <Slider disabled={frequencyLock} defaultValue={1} step={1} marks min={1} max={10} valueLabelDisplay="auto" value={profileContext[5]} onChange={handleFrequency}></Slider> */}
                        {/* {frequencyLock === false ?
                        <FontAwesomeIcon icon={faLockOpen} size="lg" className="lockIcon" onClick={handleFrequencyLock}/>
                    : (
                        <FontAwesomeIcon icon={faLock} size="lg" className="lockIcon" onClick={handleFrequencyLock}/>
                    )} */}
                    </div>
                </div>

                </div>
                            <button className="save__profile__button" onClick={handleSave}>Save</button>
                            {/* <button className="saveProfileButton" onClick={handleResetValues}>Reset Values</button> */}
                        </div>
                    </div>
                )}
                {/* {tabIndex === 2 && (
                  <ProfileListComponent stateFunctions={[setTabIndex, setCompareProfileName, setCompareFlowRate, setCompareHv, setCompareLv, setCompareDutyCycle, setCompareFrequency]}/>
                ) } */}

                </Box>
            </div>
        </div>
    </div>

    )
}

export default HomeComponent